function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  label {\n    ",
        "\n  }\n\n  div {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect } from "react";
import propTypes from "prop-types";
import { DragDropContext } from "react-beautiful-dnd";
import { FaPlus } from "react-icons/fa";
import ItemGroup from "./ItemGroup";
import { PhaseAllocationsActionsEnum, usePhasesReducer } from "./stateReducer";
import { sumBy } from "lodash";
import { Grid, WrRow as Row, WrCol as Col } from "../../grid";
import BackButton from "../../back-button";
import Button from "../../button";
import { Redirect } from "react-router";
import { context, withContext } from "../../wr-context";
import styled from "styled-components";
import * as phasesModule from "../../../modules/phases";
import formatCurrency from "../../../utils/format-currency";
import { updateContextState } from "../../wr-context";
import Tooltip from "../../Tooltip";
import { buildConfirmationModal } from "../../modal/builders";
import { ConfirmationText } from "./ItemGroup/styles";
var _utils = phasesModule.utils, sumCosts = _utils.sumCosts, calculateItemGroupCost = _utils.calculateItemGroupCost, calculateItemGroupHours = _utils.calculateItemGroupHours, calcBidMargin = _utils.calcBidMargin;
var ValueColumn = styled(Col)(_templateObject(), function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : ref.itemGroup.valueColumn.container;
}, function(param) {
    var theme = param.theme;
    var ref;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : ref.itemGroup.valueColumn.label;
}, function(param) {
    var theme = param.theme;
    var ref, ref1, ref2;
    return (ref = theme.components.phases) === null || ref === void 0 ? void 0 : (ref1 = ref.itemGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.valueColumn) === null || ref2 === void 0 ? void 0 : ref2.div;
});
var augmentGetClassName = function(getClassName) {
    return function(opts) {
        var ref;
        if (getClassName) {
            var result = getClassName(opts);
            if (typeof result === "string") return result;
        }
        return ((ref = opts.containerProps) === null || ref === void 0 ? void 0 : ref.className) || opts.props.className;
    };
};
function _PhaseAllocations(props) {
    var _items = props.items, items = _items === void 0 ? [] : _items, phasesConfig = props.phasesConfig, selectedRegion = props.selectedRegion, onSubmit = props.onSubmit, _$formatCurrency = props.formatCurrency, disabled = props.disabled, reducerOverride = props.reducerOverride, shouldRedirect = props.shouldRedirect, _hasEstimationInWeeks = props.hasEstimationInWeeks, hasEstimationInWeeks = _hasEstimationInWeeks === void 0 ? false : _hasEstimationInWeeks, _usesDecimalNumbers = props.usesDecimalNumbers, usesDecimalNumbers = _usesDecimalNumbers === void 0 ? false : _usesDecimalNumbers, customComponents = props.customComponents, _hideDropdownsRow = props.hideDropdownsRow, hideDropdownsRow = _hideDropdownsRow === void 0 ? false : _hideDropdownsRow, disableAddPhaseButton = props.disableAddPhaseButton;
    console.log({
        items: items,
        phasesConfig: phasesConfig
    });
    var getClassName = augmentGetClassName(props.getClassName);
    var ref = _slicedToArray(usePhasesReducer(reducerOverride, phasesConfig, items), 2), state = ref[0], dispatch = ref[1];
    useEffect(function() {
        return updateContextState(function(ctxState) {
            ctxState.phasesConfig = state;
        });
    }, [
        state
    ]);
    var costOptions = {
        rateOverrideKey: selectedRegion,
        getDiscount: props.getDiscount,
        getPrice: props.getAddonPrice
    };
    var totalRateCents = state.itemGroups.reduce(function(memo, itemGroup) {
        return sumCosts(memo, calculateItemGroupCost(itemGroup, costOptions));
    }, {});
    var totalHours = sumBy(state.itemGroups.map(function(itemGroup) {
        return calculateItemGroupHours(itemGroup);
    }));
    if (!items.length && shouldRedirect) {
        return /*#__PURE__*/ React.createElement(Redirect, {
            to: context.getRoutePath("index")
        });
    }
    var onProceed = function() {
        if (onSubmit) {
            onSubmit();
        } else {
            context.history.push(context.getRoutePath("gantt"));
        }
    };
    var isDisabledCb = typeof disabled === "function" ? disabled : function() {
        return !!disabled;
    };
    var isAddPhasesDisabledCb = typeof disableAddPhaseButton === "function" ? disableAddPhaseButton : function() {
        return !!disableAddPhaseButton;
    };
    var addPhaseButton = /*#__PURE__*/ React.createElement(Tooltip, {
        tooltip: "It\u2019s not possible to have more phases than services",
        options: {
            placement: "bottom-start",
            visible: isAddPhasesDisabledCb() ? undefined : false
        },
        style: {
            display: "inline-flex"
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        disabled: isDisabledCb() || isAddPhasesDisabledCb(),
        onClick: function() {
            return dispatch({
                type: PhaseAllocationsActionsEnum.AddGroup
            });
        }
    }, /*#__PURE__*/ React.createElement(FaPlus, null), " Add Phase"));
    var effortUnit = hasEstimationInWeeks ? "WEEKS" : "HOURS";
    return /*#__PURE__*/ React.createElement(Grid, {
        className: getClassName({
            type: "root",
            props: props
        })
    }, /*#__PURE__*/ React.createElement(Row, {
        between: "xs"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }, /*#__PURE__*/ React.createElement(BackButton, {
        onClick: function() {
            context.actions.openModal(buildConfirmationModal({
                body: /*#__PURE__*/ React.createElement(ConfirmationText, null, "Are you sure you want to continue? The changes made on this page will be lost."),
                onConfirm: function() {
                    context.history.goBack();
                }
            }));
        }
    }))), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(Row, {
        between: "xs"
    }, props.displayAddPhaseButton && /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }, addPhaseButton), props.displayBidMargin && /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: props.displayDiscountedPrice ? 2 : 4
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": "phase-allocations-big-margin"
    }, calcBidMargin(totalRateCents), "%"), /*#__PURE__*/ React.createElement("label", null, "Bid Margin")), /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: 2
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": "phase-allocations-total-unit"
    }, totalHours), /*#__PURE__*/ React.createElement("label", null, "TOTAL # OF ", effortUnit)), /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: 2
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": "phase-allocations-list-price"
    }, _$formatCurrency === null || _$formatCurrency === void 0 ? void 0 : _$formatCurrency(totalRateCents.fullCost / 100)), /*#__PURE__*/ React.createElement("label", null, "List Price")), props.displayDiscountedPrice && /*#__PURE__*/ React.createElement(ValueColumn, {
        xs: 2
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": "phase-allocations-discounted-price"
    }, _$formatCurrency === null || _$formatCurrency === void 0 ? void 0 : _$formatCurrency(totalRateCents.discountedCost / 100)), /*#__PURE__*/ React.createElement("label", null, "Discounted Price")), /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: onProceed
    }, "Proceed"))), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(DragDropContext, {
        onDragEnd: function(dndParams) {
            return dispatch({
                type: PhaseAllocationsActionsEnum.MoveItem,
                dndParams: dndParams
            });
        }
    }, state.itemGroups.map(function(itemGroup, i) {
        return /*#__PURE__*/ React.createElement(ItemGroup, {
            key: i,
            itemGroup: itemGroup,
            index: i,
            selectedRegion: selectedRegion,
            dispatch: dispatch,
            getClassName: getClassName,
            renderItemRowHeader: props.renderItemRowHeader,
            renderHeader: props.renderItemGroupHeader,
            getDiscount: props.getDiscount,
            getAddonPrice: props.getAddonPrice,
            formatCurrency: _$formatCurrency,
            isDisabledCb: isDisabledCb,
            displayItemRowControls: props.displayItemRowControls,
            displayDiscountedPrice: props.displayDiscountedPrice,
            effortUnit: effortUnit,
            usesDecimalNumbers: usesDecimalNumbers,
            customComponents: customComponents,
            hideDropdownsRow: hideDropdownsRow
        });
    })), /*#__PURE__*/ React.createElement("br", null), props.displayAddPhaseButton && addPhaseButton);
}
_PhaseAllocations.propTypes = {
    items: propTypes.array,
    actions: propTypes.shape({
        removeProductFromCart: propTypes.func.isRequired
    }),
    selectedRegion: propTypes.string,
    displayBidMargin: propTypes.bool,
    onSubmit: propTypes.func,
    getClassName: propTypes.func,
    renderItemRowHeader: propTypes.func,
    renderItemGroupHeader: propTypes.func,
    getDiscount: propTypes.func,
    getAddonPrice: propTypes.func,
    formatCurrency: propTypes.func,
    displayAddPhaseButton: propTypes.bool,
    displayDiscountedPrice: propTypes.bool,
    displayItemRowControls: propTypes.bool,
    shouldRedirect: propTypes.bool,
    hasEstimationInWeeks: propTypes.bool,
    customComponents: propTypes.array,
    hideDropdownsRow: propTypes.bool
};
_PhaseAllocations.defaultProps = {
    displayBidMargin: false,
    displayAddPhaseButton: true,
    displayDiscountedPrice: true,
    displayItemRowControls: true,
    shouldRedirect: true,
    formatCurrency: formatCurrency,
    getClassName: function(opts) {
        var ref, ref1;
        return (opts === null || opts === void 0 ? void 0 : (ref = opts.containerProps) === null || ref === void 0 ? void 0 : ref.className) || (opts === null || opts === void 0 ? void 0 : (ref1 = opts.props) === null || ref1 === void 0 ? void 0 : ref1.className);
    }
};
var PhaseAllocations = withContext(_PhaseAllocations, {
    mapProps: function(context) {
        return {
            actions: context.actions,
            items: context.state.selectedAddons,
            phasesConfig: context.state.phasesConfig,
            selectedRegion: context.state.selectedRegion
        };
    }
});
export default PhaseAllocations;
